import React from "react"
import theme from "@irati/ui/src/global/theme"

export interface CoordinateProps {
  cx: number
  cy: number
  opacity?: number
}

const DOT_OFFSET = 4
const ACTIVE_DOT_OFFSET = 13

export const Square = (props: CoordinateProps) => {
  const {cx, cy, opacity} = props
  return (
    <svg x={cx - DOT_OFFSET} y={cy - DOT_OFFSET} width={8} height={8} opacity={opacity}>
      <rect width={8} height={8} style={{fill: theme.colors.primary2}} />
    </svg>
  )
}

export const Circle = (props: CoordinateProps) => {
  const {cx, cy, opacity} = props
  return (
    <svg x={cx} y={cy} opacity={opacity} style={{overflow: "visible"}}>
      <circle r={4} style={{fill: theme.colors.primary1}} />
    </svg>
  )
}

export const Triangle = (props: CoordinateProps) => {
  const {cx, cy, opacity} = props
  return (
    <svg x={cx - DOT_OFFSET} y={cy - DOT_OFFSET} height={8} width={8} opacity={opacity}>
      <path d="M4 0L8 8H0L4 0Z" fill={theme.colors.tertiary.p_400} />
    </svg>
  )
}

export const Pentagon = (props: CoordinateProps) => {
  const {cx, cy, opacity} = props
  return (
    <svg x={cx - DOT_OFFSET} y={cy - DOT_OFFSET} width={8} height={8} opacity={opacity}>
      <path d="M4 0L7.80423 2.76393L6.35114 7.23607H1.64886L0.195774 2.76393L4 0Z" fill={theme.colors.tertiary.i_400} />
    </svg>
  )
}

export const Rect = (props: CoordinateProps) => {
  const {cx, cy, opacity} = props
  return (
    <svg x={cx - DOT_OFFSET} y={cy - DOT_OFFSET} width={4} height={8} opacity={opacity}>
      <rect width={4} height={8} style={{fill: theme.colors.secondary1}} />
    </svg>
  )
}

export const ActiveSquare = (props: CoordinateProps) => {
  const {cx, cy} = props
  return (
    <svg x={cx - ACTIVE_DOT_OFFSET} y={cy - ACTIVE_DOT_OFFSET} width="27" height="30" viewBox="0 0 27 30" fill="none">
      <g filter="url(#filter0_dd)">
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" fill="white" />
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" stroke="#21295C" strokeWidth="2.4" />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0.800049"
          y="0.799805"
          width="25.4"
          height="28.3917"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.129412 0 0 0 0 0.160784 0 0 0 0 0.360784 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export const ActiveCircle = (props: CoordinateProps) => {
  const {cx, cy} = props
  return (
    <svg x={cx - ACTIVE_DOT_OFFSET} y={cy - ACTIVE_DOT_OFFSET} width="27" height="30" viewBox="0 0 27 30" fill="none">
      <g filter="url(#filter0_dd)">
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" fill="white" />
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" stroke="#0496FF" strokeWidth="2.4" />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0.800049"
          y="0.799805"
          width="25.4"
          height="28.3917"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0156863 0 0 0 0 0.588235 0 0 0 0 1 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export const ActiveTriangle = (props: CoordinateProps) => {
  const {cx, cy} = props
  return (
    <svg x={cx - ACTIVE_DOT_OFFSET} y={cy - ACTIVE_DOT_OFFSET} width="27" height="30" viewBox="0 0 27 30" fill="none">
      <g filter="url(#filter0_dd)">
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" fill="white" />
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" stroke="#FF4270" strokeWidth="2.4" />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0.800049"
          y="0.799805"
          width="25.4"
          height="28.3917"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.258824 0 0 0 0 0.439216 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export const ActivePentagon = (props: CoordinateProps) => {
  const {cx, cy} = props
  return (
    <svg x={cx - ACTIVE_DOT_OFFSET} y={cy - ACTIVE_DOT_OFFSET} width="27" height="30" viewBox="0 0 27 30" fill="none">
      <g filter="url(#filter0_dd)">
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" fill="white" />
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" stroke="#8352E1" strokeWidth="2.4" />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0.800049"
          y="0.799805"
          width="25.4"
          height="28.3917"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.513726 0 0 0 0 0.321569 0 0 0 0 0.882353 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export const ActiveRect = (props: CoordinateProps) => {
  const {cx, cy} = props
  return (
    <svg x={cx - ACTIVE_DOT_OFFSET} y={cy - ACTIVE_DOT_OFFSET} width="27" height="30" viewBox="0 0 27 30" fill="none">
      <g filter="url(#filter0_dd)">
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" fill="white" />
        <ellipse cx="13.5" cy="13.9959" rx="7.5" ry="7.99587" stroke="#3DCCC7" strokeWidth="2.4" />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0.800049"
          y="0.799805"
          width="25.4"
          height="28.3917"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.8 0 0 0 0 0.780392 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
